import { AwardCount, ProfileUrl } from "@hubcapp/types";

export enum BadgeType {
  Green = "Green",
  Pink = "Pink",
}

export type BasicDetailsFormFields = {
  displayName?: string | null;
  additionalLanguages?: string[] | null;
};

export type BioFormFields = {
  badgeDate?: Date | null;
  bio?: string | null;
} & TagQuestions;

export type Question = {
  key: keyof TagQuestions;
  label: string;
  tags: string[];
};

export type TagQuestions = {
  teaching_enjoyment?: string[] | null;
  teaching_style?: string[] | null;
  most_rewarding_aspect?: string[] | null;
  self_description?: string[] | null;
  free_time_activities?: string[] | null;
};

export type ProfileDetailsFormFields = BasicDetailsFormFields & BioFormFields;

export type BasicDetailsFormActions = {
  onDisplayNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onAdditionalLanguageChange: (newValues: string[]) => void;
};

export type BioFormActions = {
  onBadgeDateChange: (badgeDate: string) => void;
  onQuestionChange: (key: string, newValues: string[]) => void;
  onGenerateBioClick: () => void;
};

export type BasicDetailsProps = {
  values?: BasicDetailsFormFields;
  additionalLanguageOptions: string[];
  errors?: Record<string, any>;
  loading?: boolean;
} & BasicDetailsFormActions;

export type BioProps = {
  values?: BioFormFields;
  badgeType: BadgeType;
  errors?: Record<string, any>;
  isGeneratingBio?: boolean;
  loading?: boolean;
  isBioGenerationDisabled?: boolean;
  onEditAnswersClick?: () => void;
  onClearBioClick?: () => void;
  showBioForm?: boolean;
} & BioFormActions;

export type ProfileDetailsProps = {
  basicDetails?: BasicDetailsFormFields;
  bioValues?: BioFormFields;
  additionalLanguageOptions: string[];
  badgeType: BadgeType;
  onBackClicked: () => void;
  errors?: Record<string, any>;
  loading?: boolean;
  isGeneratingBio?: boolean;
  isBioGenerationDisabled?: boolean;
  onEditAnswersClick?: () => void;
  onClearBioClick?: () => void;
  showBioForm?: boolean;
} & BioFormActions &
  BasicDetailsFormActions;

export type ProfileDetailsCardProps = {
  displayName?: string;
  profileUrls?: ProfileUrl[];
  additionalLanguages?: string[];
  bio?: string;
  loading?: boolean;
  awards?: AwardCount[];
  handleAddDetailsOnClick?: () => void;
};

export type BusinessProfileUrlCardProps = {
  profileUrls?: ProfileUrl[];
};

export type MyBusinessProfileProps = {
  profileDetails?: ProfileDetailsCardProps;
};

export type AdditionalLanguagesMultiSelectProps = {
  values: string[];
  additionalLanguageOptions: string[];
  onAdditionalLanguageChange: (newValues: string[]) => void;
};
